import { Tooltip } from 'antd';
import styles from './truncated-list.module.scss';
import type { ITruncatedListProps } from './types';

export const TruncatedList = <T,>(props: ITruncatedListProps<T>) => {
  const { items, maxVisible = 3, renderItem } = props;

  const shouldTruncate = items.length > maxVisible;

  const renderItemWithSeparator = (item: T, index: number, isLast: boolean) => {
    return (
      <span key={index} className={styles.item}>
        {renderItem(item)}
        {!isLast && <small> &#8594; </small>}
      </span>
    );
  };

  const renderFullList = () => {
    return items.map((item, index) => renderItemWithSeparator(item, index, index === items.length - 1));
  };

  const renderTruncatedView = () => {
    const firstItem = items[0];
    const lastItem = items[items.length - 1];

    return (
      <>
        <span className={styles.item}>{renderItem(firstItem)}</span>
        <small> &#8594; </small>
        <small>...</small>
        <small> &#8594; </small>
        <span className={styles.item}>{renderItem(lastItem)}</span>
      </>
    );
  };

  if (items.length === 0) {
    return null;
  }

  return (
    <div>
      {shouldTruncate ? (
        <Tooltip title={renderFullList()}>
          <span>{renderTruncatedView()}</span>
        </Tooltip>
      ) : (
        renderFullList()
      )}
    </div>
  );
};
